import { AlertTriangle } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogOverlay,
  AlertDialogPortal,
} from './ui/alert-dialog';

interface SessionTimeoutWarningModalProps {
  open: boolean;
  remainingSeconds: number;
  isRefreshing: boolean;
  onContinue: () => void;
  onLogout: () => void;
}

export function SessionTimeoutWarningModal({
  open,
  remainingSeconds,
  isRefreshing,
  onContinue,
  onLogout,
}: SessionTimeoutWarningModalProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogPortal>
        <AlertDialogOverlay 
          className="fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
          style={{ willChange: 'opacity' }}
        />
        <AlertDialogContent 
          className="fixed left-[50%] top-[50%] z-50 translate-x-[-50%] translate-y-[-50%]"
          style={{ willChange: 'transform' }}
        >
          <AlertDialogHeader>
            <AlertDialogTitle className="flex items-center gap-2 text-amber-700">
              <AlertTriangle className="h-5 w-5" />
              Sesion por expirar
            </AlertDialogTitle>
            <AlertDialogDescription>
              Tu sesion expirara en <strong>{remainingSeconds}</strong> segundos por inactividad.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={onLogout} disabled={isRefreshing}>
              Cerrar sesion
            </AlertDialogCancel>
            <AlertDialogAction onClick={onContinue} disabled={isRefreshing}>
              {isRefreshing ? 'Extendiendo...' : 'Continuar trabajando'}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogPortal>
    </AlertDialog>
  );
}
